if (!customElements.get('keyzen-payment-options')) {
  customElements.define('keyzen-payment-options', class extends HTMLElement {
    connectedCallback() {
      this.updateLabel();
      this.observer = new MutationObserver(() => this.updateLabel());
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateLabel() {
      const label = this.dataset.label;
      if (!label) return;

      this.querySelectorAll('.shopify-payment-button__more-options').forEach(button => {
        if (button.textContent !== label) button.textContent = label;
      });
    }
  });
}
